// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Success_wrapper__kPoUg","header":"Success_header__XnZNr","icon":"Success_icon__PQ_zp"};